module.exports = __webpack_public_path__ + "media/casual_game_track.b4e25b0a.mp3";